import React from 'react';
import { Button } from 'primereact/button';
import useRepairSlipReport from './hooks/useRepairSlipReport';
import RepairSlipReportTable from './components/RepairSlipReportTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportRepairSlipReportToExcelQuery } from '../../../api/endpoints/repairSlipReport';

const RepairSlipReportPage = () => {
    const { th } = useLanguage();

    const { items, totalCount, isLoading, lazyParams, activeFilters, filterOptions, sortField, sortOrder, exportParams, onPage, onSort, handleFilterChange, initFilters } = useRepairSlipReport();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('repairSlipReport.title')}</h1>
                <div className="flex gap-2">
                    <Button icon="pi pi-filter-slash" className="p-button-outlined p-button-secondary" onClick={initFilters} tooltip={th('filter.reset')} tooltipOptions={{ position: 'left' }} />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportRepairSlipReportToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel={th('common.export')}
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'RepairSlipReport.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
                </div>
            </div>

            <RepairSlipReportTable
                items={items}
                totalCount={totalCount}
                loading={isLoading}
                lazyParams={lazyParams}
                onPage={onPage}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                filterOptions={filterOptions}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
            />
        </div>
    );
};

export default RepairSlipReportPage;
